import { HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";

export const getDwollaBalance = async () => {
  const res = await HttpPromiseWithEntireResponse({
    method: "GET",
    url: "api/distributor/payments/balance",
  });

  if(res.ok) return await res.json()
  return null;
};
